<script setup lang="ts">
/**
 * Design System Container Component
 * Provides consistent max-width and padding across the site
 *
 * @example
 * <DSContainer>
 *   Your content here
 * </DSContainer>
 */

interface Props {
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '7xl' | 'full'
  padding?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  maxWidth: '7xl',
  padding: true
})

const containerClasses = computed(() => {
  const classes = ['mx-auto']

  // Max width
  const widthMap = {
    'sm': 'max-w-sm',
    'md': 'max-w-md',
    'lg': 'max-w-lg',
    'xl': 'max-w-xl',
    '2xl': 'max-w-2xl',
    '7xl': 'max-w-7xl',
    'full': 'max-w-full'
  }
  classes.push(widthMap[props.maxWidth])

  // Padding
  if (props.padding) {
    classes.push('px-4', 'sm:px-6', 'lg:px-8')
  }

  return classes.join(' ')
})
</script>

<template>
  <div :class="containerClasses">
    <slot />
  </div>
</template>
